import { createServerFn } from "@tanstack/react-start";
import { authMiddleware } from "~/lib/auth-middleware";
import { initializeClerkIfNeeded, getClerk } from "~/lib/clerk-server";

interface UserPasswordStatus {
  hasPassword: boolean;
}

export const getUserPasswordStatus = createServerFn({ method: "GET" })
  .middleware([authMiddleware])
  .handler(async ({ context }): Promise<UserPasswordStatus> => {
    const clerkUserId = context.user.clerkUserId;

    if (!clerkUserId) {
      return { hasPassword: false };
    }

    await initializeClerkIfNeeded();
    const clerk = getClerk();

    try {
      const clerkUser = await clerk.users.getUser(clerkUserId);
      const hasPassword = Boolean(clerkUser.passwordEnabled);

      return { hasPassword };
    } catch (error) {
      console.error("Failed to determine user password status", error);
      throw new Error("Unable to verify password status");
    }
  });
